import { ErrorWithResourceKey } from '../../shared/errorWithResourceKey';

export class PermissionDeniedError extends ErrorWithResourceKey {
    constructor() {
        super('PermissionDeniedError', undefined, 'errors.insufficient-rights');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/database/permissionDeniedError.ts